import { useEffect, useRef } from "react";
import ZonesDataTypes, {
  PointLocation,
  PolygonLocation,
} from "../../sites/types";
import api from "../../../api/axiosConfig";
import moment from "moment";

const useGeofencesMarker = (
  map: google.maps.Map | undefined,
  geofences: ZonesDataTypes[],
  siteTypes: string[],
  clientID?: string
) => {
  const polygonRef = useRef<google.maps.Polygon[]>([]);
  const circlesRef = useRef<google.maps.Circle[]>([]);
  const siteTypesRef = useRef(siteTypes);
  siteTypesRef.current = siteTypes;

  const fetchClient = async (id: string) => {
    return await api
      .get(`/clients/${id}`)
      .then((res) => res.data)
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (!map) return;

    circlesRef.current.forEach((c) => c.setMap(null));
    polygonRef.current.forEach((p) => p.setMap(null));
    circlesRef.current = [];
    polygonRef.current = [];

    if (!siteTypesRef.current.includes("geofence")) return;

    const currentDate = moment();
    const filteredGeofences = geofences
      ?.filter((geofence) =>
        !clientID || clientID === "all"
          ? geofence
          : geofence?.clientID === clientID
      )
      .filter((geofence) => {
        if (geofence.alwaysActive) return geofence;
        if (moment(geofence.expiresAt).isBefore(currentDate)) return null;
        if (moment(geofence.startsAt).isAfter(currentDate)) return null;
        return geofence;
      });

    const infowindow = new google.maps.InfoWindow();
    const polygons: google.maps.Polygon[] = [];
    const circles: google.maps.Circle[] = [];

    filteredGeofences.forEach((geofence) => {
      const geofenceStringDiv = async () => {
        const client = await fetchClient(geofence.clientID);
        const convertedStartTime = moment(geofence.startsAt).format(
          "YYYY-MM-DD HH:mm:ss Z"
        );
        const convertedExpiresTime = moment(geofence.expiresAt).format(
          "YYYY-MM-DD HH:mm:ss Z"
        );
        return `<div style="font-size: 14px;  padding: 16px">
        <div>
          <p>
            <span style="font-weight: 500;">Geofence Name:</span>
            ${geofence.name}
          </p>
          <p>
            <span style="font-weight: 500;">Client:</span>
            ${client.name}
          </p>
          ${
            geofence.alwaysActive
              ? "<span style=\"font-weight: 500;\">Permanent Geofence</span>"
              : `          <p>
            <span style="font-weight: 500;">Geofence Starts At:</span>
            ${convertedStartTime}
          </p>
          <p>
            <span style="font-weight: 500;">Geofence Expires At:</span>
            ${convertedExpiresTime}
          </p>`
          }

        </div>
      </div>`;
      };

      if (geofence.location.type === "Point") {
        const location = geofence.location as PointLocation;
        const coordinates = location.coordinates;
        const lng = coordinates[0] as number;
        const lat = coordinates[1] as number;
        const position = { lng, lat };
        const circle = new google.maps.Circle({
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35,
          map,
          center: position,
          radius: geofence.location.properties.radius,
        });
        circle.setMap(map);
        circle.addListener("click", async (e: google.maps.MapMouseEvent) => {
          infowindow.setContent(await geofenceStringDiv());
          infowindow.setPosition({
            lng: e.latLng!.lng(),
            lat: e.latLng!.lat(),
          });
          infowindow.open(map);
        });
        return circles.push(circle);
      } else {
        const location = geofence.location as PolygonLocation;
        const coordinates = location.coordinates.flatMap((coords) => coords);
        const path = coordinates.map((coords) => ({
          lng: coords[0],
          lat: coords[1],
        }));
        const polygon = new google.maps.Polygon({
          strokeWeight: 2,
          paths: path,
          fillOpacity: 0.35,
          fillColor: "#FF0000",
          strokeColor: "#FF0000",
        });

        polygon.addListener("click", async (e: google.maps.MapMouseEvent) => {
          infowindow.setContent(await geofenceStringDiv());
          infowindow.setPosition({
            lat: e.latLng!.lat(),
            lng: e.latLng!.lng(),
          });
          infowindow.open(map);
        });
        polygon.setMap(map);
        return polygons.push(polygon);
      }
    });

    circlesRef.current = circles;
    polygonRef.current = polygons;
  }, [geofences, map, clientID, siteTypes]);
};

export default useGeofencesMarker;
